import { City } from '../types/city';
import axiosInstance from './Instance/axiosInstance';



export const fetchCities = async (): Promise<City[]> => {
    const response = await axiosInstance.get('/city');
    return response.data;
};

export const createCity = async (city: City): Promise<City> => {
    const response = await axiosInstance.post('/city', city);
    return response.data;
};

export const deleteCityApi = async (id: string): Promise<City> => {
    const response = await axiosInstance.delete(`/city/${id}`);
    return response.data;
};
export const updateCityApi = async (city: City, id: string): Promise<City> => {
    const response = await axiosInstance.put(`/city/${id}`, city);
    return response.data;
};